<template>
  <div id="app">
    <router-view class="view"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return{
      title:'',
      // timer:null
    }
  },
  mounted:function(){
    let _this=this
    // var check=['/companyee_insert','/needs']
    var check=['/companyee_insert','/needs']
    if (_this._isMobile()){
      if(check.indexOf(location.pathname)==-1 && location.pathname.indexOf('share')=='-1'){
          window.open('https://edu.zhiyaozhishi.com/')
      }
    }
    // if(_this.timer == null) {
    //   _this.timer = setInterval( () => {
    //       _this.check()
    //   }, 5000)
    // }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    // check() {
    //   let _this=this;
    //   var check=['/client_download']
    //   if(check.indexOf(_this.$router.currentRoute.path)!=-1){
    //     if (localStorage.authorization) {  // 判断当前的token是否存在
    //       _this.axios.post('/v2/login/check',).then(function (res) {
    //         if(res.data.code=='-1'){
    //           if(_this.$router.currentRoute.path.indexOf('login')==-1){
    //             _this.$message.error(res.data.msg)
    //             localStorage.setItem('authorization', '')
    //             _this.$store.commit('info_save', null)
    //             setTimeout(()=>{
    //               _this.$router.push({
    //                 path: '/login',
    //                 query: {redirect: _this.$route.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
    //               });
    //             },3000)
    //           }
    //         }
    //       }).catch(function (error) {
    //         _this.$message.error('服务器内部错误')
    //       })
    //     }
    //   }
    // },
  }
}
</script>

<style >
#app {
  font-size: 0.8125rem;
  /* background-color: #f6f8ff; */
}
body{
  margin: 0;
  background-color: #f6f8ff;
}
.left{
  float: left;
}
.right{
  float: right;
}
.center{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue